import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import whiteLogo from "../../assets/images/logos/Redesign_Logótipo_(branco).svg";
import { HeaderIcons } from "./HeaderIcons";
import { HeaderDesktopNav } from "./HeaderDesktopNav";
import { HeaderMobileMenu } from "./HeaderMobileMenu";
import { HeaderSearch } from "./HeaderSearch";
import { AuthModal } from "../AuthModal";
import { CartModal } from "../CartModal";
import { useLocalizedNavigation } from "../../hooks/useLocalizedNavigation";

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activePanel, setActivePanel] = useState(null);
  const location = useLocation();
  const { localizePath } = useLocalizedNavigation();

  useEffect(() => {
    setMenuOpen(false);
    setActivePanel(null);
  }, [location.pathname]);

  const handleTogglePanel = (panel) => {
    setActivePanel((prev) => (prev === panel ? null : panel));
  };

  return (
    <header className="header">
      <ul className="header__list">
        <li className="header__logo">
          <Link to={localizePath("/")}>
            <img src={whiteLogo} alt="Homepage Mafirol" />
          </Link>
        </li>

        <HeaderDesktopNav />
        <HeaderIcons activePanel={activePanel} onTogglePanel={handleTogglePanel} />

        <HeaderMobileMenu
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          searchOpen={activePanel === "search"}
          setSearchOpen={(value) => handleTogglePanel(value ? "search" : null)}
          query={searchQuery}
          setQuery={setSearchQuery}
        />
      </ul>

      <HeaderSearch
        searchOpen={activePanel === "search"}
        setSearchOpen={(value) => handleTogglePanel(value ? "search" : null)}
        query={searchQuery}
        setQuery={setSearchQuery}
      />

      <AuthModal isOpen={activePanel === "auth"} close={() => setActivePanel(null)} />
      <CartModal isOpen={activePanel === "cart"} close={() => setActivePanel(null)} />
    </header>
  );
};
